// extracted by mini-css-extract-plugin
module.exports = {"root":"PaymentsMobile_root___q2rw","item":"PaymentsMobile_item__1-fEW","label":"PaymentsMobile_label__1HdWF","amount":"PaymentsMobile_amount__5KObw"};